function parseJwt(token) {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
        return null;
    }
}

// Decodes the JWT and stores its issued/expiry timestamps in localStorage.
function storeTokenTimestamps(token) {
    const payload = parseJwt(token);
    if (!payload?.exp) return;

    localStorage.setItem('tokenIssuedAt', payload.iat);
    localStorage.setItem('tokenExpiresAt', payload.exp);
    localStorage.setItem('tokenExpiresAtLocal', new Date(payload.exp * 1000).toLocaleString());
}

function clearTokenTimestamps() {
    localStorage.removeItem('tokenIssuedAt');
    localStorage.removeItem('tokenExpiresAt');
    localStorage.removeItem('tokenExpiresAtLocal');
}

// Milliseconds remaining until the stored token expires, or null if there's nothing stored.
function getMsUntilTokenExpiry() {
    const expiresAt = Number(localStorage.getItem('tokenExpiresAt'));
    if (!expiresAt) return null;
    return expiresAt * 1000 - Date.now();
}

export { parseJwt, storeTokenTimestamps, clearTokenTimestamps, getMsUntilTokenExpiry };
